import React from 'react';
import { Select } from 'antd';
import { SelectPropsEnums } from 'enums/COSelectEnums';
import clsx from 'clsx';
import styles from './COSelectSearch.module.scss';
import { Field, FieldProps, FormikValues, useField } from 'formik';
import Error from '../Error';
import { ReactComponent as Arrow } from 'assets/icons/arrow.svg';


export interface SelectProps {
  multiSelect?: boolean;
  options?: any[];
  handleMultiSelectChange?: (values: string[]) => void;
  name: string;
  placeholderstring: string;
  disabled?: boolean;
  label?: string;
  dropdownRender?: (menu: React.ReactElement) => React.ReactElement;
  onChange?: (value: any) => void;
  onFocus?: (event: React.FocusEvent<HTMLElement>) => void;
}

const COSelectSearch: React.FC<SelectProps> = props => {
  const {
    name,
    multiSelect,
    options,
    handleMultiSelectChange,
    placeholderstring,
    label,
    disabled,
    dropdownRender,
    onChange,
    onFocus,
  } = props;
  const [showLabel, setshowLabel] = React.useState<boolean>(false);

  const [field, meta, helpers] = useField(props);
  const InputFieldContainerClass = clsx({
    [styles.inputFieldContainer]: true,
    [styles.error]: meta.touched && meta.error,
  });
  const LabelClass = clsx({
    [styles.labelFloat]: true,
    [styles.error]: meta.touched && meta.error,
  });

  if (multiSelect) {
    return (
      <Select
        showSearch
        data-testid={name}
        suffixIcon={<Arrow fontSize={44} />}
        mode={SelectPropsEnums.MODE}
        options={options}
        onChange={newValue =>
          handleMultiSelectChange &&
          handleMultiSelectChange(newValue as string[])
        }
        placeholder={placeholderstring}
        maxTagCount={SelectPropsEnums.MAX_TAG_COUNT_RESPONSIVE}
        dropdownRender={dropdownRender}
      />
    );
  } else {
    return (
      <div className={InputFieldContainerClass}>
        {(showLabel || field.value) && (
          <label htmlFor={name} className={LabelClass}>
            {' '}
            {label}
          </label>
        )}

        <Field name={name}>
          {({ field, form }: FieldProps<FormikValues>) => (
            <>
              <Select
                showSearch
                {...field}
                data-testid={name}
                disabled={disabled}
                dropdownRender={dropdownRender}
                suffixIcon={<Arrow fontSize={44} />}
                placeholder={placeholderstring}
                onFocus={value => {
                  setshowLabel(true);
                  onFocus && onFocus(value);
                }}
                onChange={newValue => {
                  form.setFieldValue(field.name, newValue);
                  onChange && onChange(newValue);
                }}
                onBlur={() => helpers.setTouched(true)}
                options={options}
                filterOption={(input, option) =>
                  (option?.label?.toLowerCase() ?? '').includes(
                    input.toLowerCase()
                  )
                }
                filterSort={(optionA, optionB) =>
                  (optionA?.label ?? '')
                    .toLowerCase()
                    .localeCompare((optionB?.label ?? '').toLowerCase())
                }
                optionFilterProp="children"
                listHeight={120}
              />
              {meta.error && meta.touched && (
                <Error message={meta.error?.toString()} />
              )}
            </>
          )}
        </Field>
      </div>
    );
  }
};

export default COSelectSearch;
